/* TODO: t() */
import React, { Component, Fragment } from 'react';
import { View, StyleSheet } from 'react-native';
import FormFieldEditor from '../helpers/FormFieldEditor';
import {
  Checkbox,
  RadioGroup,
  RadioItem,
  Text,
  TextInput,
} from '../../../uiold';
import FormBuilderActions from '../../../../support/FormBuilderActions';
import Dropdown from '../../../uiold/DropdownSimple';
import { ALL_TYPES, getName, getPlaceholder } from './validators';

import TextInputElement from '../TextInputElement';

type EditorViewProps = {
  data: {
    [key: string]: unknown;
  };
  parent: TextInputElement;
  updateValue: (key: string, newValue: unknown) => void;
  renderNameInput: () => ReactElement;
  renderLabelInput: () => ReactElement;
};

type EditorViewState = {
  placeholderState: string;
};

export type Option = { name: string; value: string | null | undefined };

const PLACEHOLDER_NONE = 'none';
const PLACEHOLDER_SAME = 'same';
const PLACEHOLDER_CUSTOM = 'custom';

const options = [
  { name: 'None', value: PLACEHOLDER_NONE },
  { name: 'Same as Label', value: PLACEHOLDER_SAME },
  { name: 'Custom', value: PLACEHOLDER_CUSTOM },
];

export const NONE = { name: 'None', value: null };
const OPTIONS: Array<Option> = [
  NONE,
  ...ALL_TYPES.map((type) => ({ name: getName(type), value: type })),
];

class EditorView extends Component<EditorViewProps, EditorViewState> {
  _placeholderSyncTimer: TimeoutID;
  constructor(props: EditorViewProps) {
    super(props);
    let { definition } = this.props.parent;
    let placeholderState;
    if (definition.placeholder == null) {
      placeholderState = PLACEHOLDER_NONE;
    } else if (definition.placeholder === definition.label) {
      placeholderState = PLACEHOLDER_SAME;
    } else {
      placeholderState = PLACEHOLDER_CUSTOM;
    }
    this.state = {
      placeholderState,
    };
  }

  // Note: This is not an ideal way to do this. We want to conditionally keep
  // placeholder in sync with label.
  componentDidUpdate(oldProps: EditorViewProps) {
    let oldData = oldProps.data;
    let { data, updateValue } = this.props;
    let { placeholderState } = this.state;
    if (placeholderState === PLACEHOLDER_SAME && data.label != null) {
      if (oldData.placeholder !== data.label) {
        clearTimeout(this._placeholderSyncTimer);
        this._placeholderSyncTimer = setTimeout(() => {
          updateValue('placeholder', data.label);
        }, 16);
      }
    }
  }
  render() {
    let {
      data,
      updateValue,
      renderNameInput,
      renderLabelInput,
      parent,
    } = this.props;
    let { placeholderState } = this.state;
    let validationType = parent.definition.field_validation;
    return (
      <Fragment>
        {renderNameInput()}
        {renderLabelInput()}
        <View accessibilityRole="label" style={styles.field}>
          <Text style={styles.label}>Validation</Text>
          <Dropdown
            options={OPTIONS}
            selectedItem={
              OPTIONS.find((option) => option.value === validationType) || NONE
            }
            onChange={this._onValidationTypeChange}
          />
        </View>
        <View style={styles.container}>
          <Text>Placeholder</Text>
          <RadioGroup
            onChange={this._onPlaceHolderRadioChange}
            selectedValue={placeholderState}
          >
            {this._renderRadioItem()}
          </RadioGroup>
          {this._renderPlaceholderInput()}
          <Checkbox
            text="Multi-Line"
            isChecked={!!data.multiline}
            onChange={(value) => updateValue('multiline', value)}
          />
          <Checkbox
            text="Required"
            isDisabled={!!data.isSystemField}
            isChecked={!!data.isSystemField || !!data.is_required}
            onChange={(value) => updateValue('is_required', value)}
          />

          <Checkbox
            text="Auto-linking"
            isChecked={!!data.auto_linking}
            onChange={(value) => updateValue('auto_linking', value)}
          />
        </View>
      </Fragment>
    );
  }

  _renderPlaceholderInput = () => {
    let { data } = this.props;
    let { placeholderState } = this.state;
    if (placeholderState !== PLACEHOLDER_CUSTOM) {
      return;
    }
    return (
      <View>
        <TextInput
          autoFocus={true}
          value={typeof data.placeholder === 'string' ? data.placeholder : ''}
          onChangeText={this._onPlaceHolderInputChange}
        />
      </View>
    );
  };

  _renderRadioItem = () =>
    options.map((option) => (
      <RadioItem key={option.value} title={option.name} value={option.value} />
    ));

  _onPlaceHolderInputChange = (value: string) => {
    let { updateValue } = this.props;
    updateValue('placeholder', value);
  };

  _onPlaceHolderRadioChange = (value: unknown) => {
    let { data, parent } = this.props;
    if (value === PLACEHOLDER_NONE) {
      FormBuilderActions.updateField(parent, { placeholder: null });
    } else if (value === PLACEHOLDER_SAME) {
      FormBuilderActions.updateField(parent, { placeholder: data.label });
    }
    if (typeof value === 'string') {
      this.setState({ placeholderState: value });
    }
  };

  _onValidationTypeChange = (option: Option) => {
    let { parent } = this.props;
    let validationType = option.value;
    let newPlaceholder = getPlaceholder(validationType);
    FormBuilderActions.updateField(parent, {
      field_validation: validationType,
      placeholder: newPlaceholder || parent.definition.placeholder,
    });
    if (newPlaceholder) {
      this.setState({ placeholderState: PLACEHOLDER_CUSTOM });
    }
  };
}

type Props = {
  parent: TextInputElement;
};

class TextInputElementFieldEditorView extends Component<Props> {
  render() {
    let { parent } = this.props;
    return <FormFieldEditor component={EditorView} parent={parent} />;
  }
}

let styles = StyleSheet.create({
  container: {
    paddingTop: 5,
  },
  field: {
    marginVertical: 10,
  },
  label: {
    fontWeight: 'normal',
  },
});

export default TextInputElementFieldEditorView;
